<script>
    import {FORM_TABLE_THEME} from "../form-table-theme";

    export default {
        name: "BaseTableLayoutProps",
        props: {
            headers: {
                type: Array,
                default: () => [],
            },
            items: {
                type: Array,
                default: () => [],
            },
            /** 어떤 테마를 적용할지 결정합니다. */
            theme: {type: String, default: FORM_TABLE_THEME.MPS},
            loading: {type: Boolean, default: false},
        }
    }
</script>